// extracted by mini-css-extract-plugin
export default {"user_info_card":"FormInformationField_user_info_card__7RUhb","label":"FormInformationField_label__YxhG1","info_container":"FormInformationField_info_container__E6Doq"};